import type { Locale } from '../locale'
import { en, type Messages } from './en'
import { ptBR } from './pt-BR'

export type { Messages }
export { en, ptBR }

export const catalogs: Record<Locale, Messages> = {
  en,
  'pt-BR': ptBR
}
